export default __webpack_public_path__ + "static/media/Minicard_Kc.884584ff.svg";